import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useHotkeys } from 'react-hotkeys-hook';
import { useSnackbar } from 'material-ui-snackbar-provider';

import Modal from '../../modules/Modal';
import { NOTIFICATION } from '../../../enums/ENUMS';
import styles from './DeleteSubGroupModal.module.scss';
import { deleteSubGroupById } from '../../../api/subGroupsApi';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import { getSubGroupsByGroupIdThunk } from '../../../store/subGroups/subGroupsSlice';

type TDeleteSubGroupModal = {
  id: string;
  open: boolean;
  switchModal: () => void;
};

const DeleteSubGroupModal: React.FC<TDeleteSubGroupModal> = ({ id, open, switchModal }) => {
  const notification = useSnackbar();
  const dispatch = useAppDispatch();
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const history = useHistory();
  const { sort, sortOption } = useAppSelector((state) => state.subGroupsStore);

  const [loading, setLoading] = useState(false);
  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteSubGroupById(id);
      switchModal();
      dispatch(getSubGroupsByGroupIdThunk({ groupId: history.location.state as string, sort, sortOption }));
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      } else {
        notification.showMessage(NOTIFICATION.NOT_DELETED);
      }
    } finally {
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={switchModal} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Are you sure you want to delete this subgroup?</div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <OutlinedButton onClick={handleDelete} kind="default">
              <div ref={submitButtonRef}>Yes, I am sure</div>
            </OutlinedButton>

            <ContainedButton kind="purple" onClick={switchModal}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteSubGroupModal;
